import "./App.css";
import MainRoute from "./router";
import "./assets/style/all.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
    <ToastContainer />
      <MainRoute />
    </>
  );
}

export default App;
